import type { ElementType } from 'react';
import {
  DashboardRounded as DashboardIcon,
  Fingerprint as FingerprintIcon,
  VerifiedUserRounded as VerifyIcon,
  AutoAwesome as VerticalsIcon,
  LayersRounded as SKUsIcon,
  HistoryEduRounded as ProvenanceIcon,
} from '@material-ui/icons';
import { CustomCube as ItemsIcon } from '../../../icons/custom-cube';
import { CustomUsers as UsersIcon } from '../../../icons/custom-users';
import { OfficeBuilding as TenantsIcon } from '../../../icons/office-building';
import { Key as InvitesIcon } from '../../../icons/key';

export interface DashboardMenuItem {
  href?: string;
  external?: boolean;
  icon: ElementType;
  items?: Array<{ href: string; title: string }>;
  title: string;
  /** Section header this item groups under (rendered above the first item of the section). */
  section?: string;
  /** Only show when the tenant has image classification enabled (Origin Identity). */
  requiresClassification?: boolean;
  /** Only show to tenant admins. */
  requiresTenantAdmin?: boolean;
  /** Only show to global (cross-tenant) admins, not tenant admins. */
  requiresGlobalAdmin?: boolean;
}

export const adminItems: DashboardMenuItem[] = [
  {
    icon: UsersIcon,
    title: 'All Users',
    href: '/users',
  },
  {
    icon: TenantsIcon,
    title: 'Tenants',
    href: '/tenants',
  },
  {
    icon: VerticalsIcon,
    title: 'Verticals',
    href: '/verticals',
  },
];

export const tenantItems: DashboardMenuItem[] = [
  // Management
  {
    section: 'Management',
    icon: DashboardIcon,
    title: 'Dashboard',
    href: '/tenants/:tenantId/events',
  },
  {
    section: 'Management',
    icon: SKUsIcon,
    title: 'SKUs',
    href: '/tenants/:tenantId/skus',
  },
  {
    section: 'Management',
    icon: ItemsIcon,
    title: 'Items',
    href: '/tenants/:tenantId/items',
  },
  // Origin Identity — only when classification is enabled for the tenant
  {
    section: 'Origin Identity',
    requiresClassification: true,
    icon: FingerprintIcon,
    title: 'Origin Fingerprinting',
    href: '/tenants/:tenantId/origin/fingerprinting',
  },
  {
    section: 'Origin Identity',
    requiresClassification: true,
    icon: VerifyIcon,
    title: 'Origin Verification',
    href: '/tenants/:tenantId/origin/verification',
  },
  // Administration
  {
    section: 'Administration',
    icon: UsersIcon,
    title: 'Users',
    href: '/tenants/:tenantId/users',
  },
  {
    section: 'Administration',
    icon: InvitesIcon,
    title: 'Invite Codes',
    href: '/tenants/:tenantId/invites',
  },
  // Settings
  {
    section: 'Settings',
    requiresTenantAdmin: true,
    icon: ProvenanceIcon,
    title: 'Provenance Events',
    href: '/tenants/:tenantId/settings/provenance-events',
  },
  {
    section: 'Settings',
    requiresTenantAdmin: true,
    requiresClassification: true,
    icon: FingerprintIcon,
    title: 'Origin Identity Flows',
    href: '/tenants/:tenantId/settings/origin-flows',
  },
  {
    section: 'Settings',
    requiresGlobalAdmin: true,
    icon: TenantsIcon,
    title: 'Tenant Administration',
    href: '/tenants/edit/:tenantId',
  },
];
